export default __webpack_public_path__ + "static/media/ornament_7.800328cd.png";